import * as React from 'react';

function SearchRegular(_a) {
    var ariaLabel = _a.ariaLabel;
    return (React.createElement("svg", { "aria-label": ariaLabel, height: "20", viewBox: "0 0 20 20", width: "20", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            React.createElement("g", { fill: "#2C6BAA", fillRule: "nonzero", transform: "translate(-10 -13)" },
                React.createElement("g", { transform: "translate(10 13)" },
                    React.createElement("path", { d: "M19.862 18.316l-4.742-4.742a.464.464 0 00-.332-.137h-.515A8.123 8.123 0 008.125 0 8.123 8.123 0 000 8.125a8.123 8.123 0 0013.437 6.148v.515c0 .125.05.243.137.332l4.742 4.742a.47.47 0 00.664 0l.882-.882a.47.47 0 000-.664zM8.125 14.374a6.248 6.248 0 01-6.25-6.25 6.248 6.248 0 016.25-6.25 6.248 6.248 0 016.25 6.25 6.248 6.248 0 01-6.25 6.25z" }))))));
}

export { SearchRegular as default };
//# sourceMappingURL=SearchRegular.esm.js.map
